import React from 'react';
import { Example } from 'examples';
import Icon from '../../src/components/Icon/Icon';

const Welcome = () =>
  <Example title="Welcome" className="no-props no-code-example">
    <article>
      <div className="wrapper">
        <Icon name="vimond"/>
        <h3 className="">vimond-core-components</h3>
        <p>The component library for Vimond Media Solutions</p>
      </div>
    </article>
    <footer>
      <a className="tertiary" href="https://github.com/vimond/vimond-core-components#readme">GitHub</a>
      <a className="tertiary" href="https://github.com/vimond/vimond-core-components/commits/master">Version history</a>
      <a className="tertiary" href="https://github.com/vimond/vimond-core-components/issues">Report issue</a>
      <a className="tertiary" href="https://vimond.com/profile">Vimond profile</a>
    </footer>
  </Example>;

export default Welcome;
